export const FoundItemsIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.69432 2.5C13.5685 2.5 16.7089 5.64039 16.7089 9.51458C16.7089 13.3888 13.5685 16.53 9.69432 16.53C5.82008 16.53 2.67969 13.3888 2.67969 9.51458C2.67969 5.64039 5.82008 2.5 9.69432 2.5Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.4688 14.6548L17.3229 17.5016"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
